import { render } from "./PlayerPublicProfile.vue?vue&type=template&id=1d374958"
import script from "./PlayerPublicProfile.vue?vue&type=script&lang=js"
export * from "./PlayerPublicProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__